export default __webpack_public_path__ + "img/user.d75a7fe1.svg";